import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

interface AcademicSession {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  schoolId: string;
}

export const useActiveAcademicSession = () => {
  const [session, setSession] = useState<AcademicSession | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchActiveSession = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get('/system-settings/academic-sessions/active');
      setSession(response.data);
      setError(null);
    } catch (err: any) {
      if (err.response?.status === 404) {
        setSession(null); // No active session
      } else {
        setError(err.message || 'Failed to fetch active session');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActiveSession();
  }, [fetchActiveSession]);

  return { session, loading, error, refreshSession: fetchActiveSession };
};
